<template>
  <v-parallax :src="hero2" height="250">
    <v-row class="fill-height text-center" align="center" justify="center">
      <v-col cols="8">
        <p class="mt-5 text-white">About Us</p>
        <h1 class="mb-2 text-white">Workforce</h1>
        <v-divider class="my-2" color="white" thickness="2"></v-divider>
        <p class="text-white mb-1 text-justify">
          WorkForce, an affiliate of New San Jose Builders,
          Inc., has been providing property management services since 2014. Managing 10
          properties across Metro Manila, we handle administration, engineering, finance,
          and contract management with a focus on tenant care and property maintenance.
          Our commitment to service excellence, innovation, and continuous improvement
          sets us apart, ensuring your investment is managed with the highest standards in
          the industry.
        </p>
      </v-col>
    </v-row>
  </v-parallax>

  <div class="py-6 align-center bg-white">
    <v-container>
      <v-row class="d-flex align-center justify-center" dense>
        <!-- Card 3 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="franchesca" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Franchesca Towers</div>
              <div class="text-subtitle-2 mt-1">
                Franchesca Tower Condominium Association, Inc., Scout Boromeo Cor. EDSA,
                Quezon City
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- Card 4 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="fortvic" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Fort Victoria</div>
              <div class="text-subtitle-2 mt-1">
                Fort Victoria Condominium Association, Inc., 5th Ave. Cor. Rizal Drive,
                BGC, Taguig City
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <v-row class="d-flex align-center justify-center" dense>
        <!-- Card 1 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="isabelle" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Isabelle De Valenzuela</div>
              <div class="text-subtitle-2 mt-1">
                Isabelle De Valenzuela Condominium Association, Inc., McArthur Highway,
                Brgy. Marulas, Valenzuela City
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- Card 2 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="manila" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria De Manila</div>
              <div class="text-subtitle-2 mt-1">
                Victoria De Manila Condominium Association, Inc., 1655 Taft Ave, Malate,
                Manila City
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <v-row class="d-flex align-center justify-center" dense>
        <!-- Card 1 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="morato" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria De Morato</div>
              <div class="text-subtitle-2 mt-1">
                Victoria De Morato Condominium Association, Inc., Sct. Borromeo St. Cor.
                Tomas Morato, Brgy. South Triangle, Quezon City
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- Card 2 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="makati" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria De Makati</div>
              <div class="text-subtitle-2 mt-1">
                Victoria De Makati Condominium Association, Inc., Washington St. Cor. Dela
                Rosa St. Pio Del Pilar, Makati City
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <v-row class="d-flex align-center justify-center" dense>
        <!-- Card 1 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="victoria1" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria Station 1</div>
              <div class="text-subtitle-2 mt-1">
                Victoria Station 1 Condominium Association, Inc., #793 EDSA GMA Kamuning,
                MRT Station, Diliman, Quezon City
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- Card 2 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="victoria2" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria Sports Tower Station II</div>
              <div class="text-subtitle-2 mt-1">
                Victoria Sports Tower Station II Condominium Association, Inc., EDSA South
                Bound #799 EDSA, South Triangle, Quezon City
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <v-row class="d-flex align-center justify-center" dense>
        <!-- Card 1 -->
        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="victoria" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria Towers</div>
              <div class="text-subtitle-2 mt-1">
                Victoria Tower Condominium Association, Inc., #79 Panay Ave. Cor. Timog,
                Diliman, Quezon City
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-4 ma-2" max-width="500" elevation="4" rounded="s">
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-img :src="manila2" aspect-ratio="1" class="rounded-lg mr-5"></v-img>
            </v-col>
            <v-col cols="7">
              <div class="text-h6 font-weight-bold">Victoria De Manila II</div>
              <div class="text-subtitle-2 mt-1">
                Victoria De Manila II Condominium Association, Inc., Taft Ave. Malate,
                Manila City
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-container>
  </div>

  <v-divider></v-divider>

  <div class="py-12 bg-white">
    <v-row class="fill-height py-6" align="center" justify="center">
      <v-img
        :src="ft"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Franchesca Tower"
      />
      <v-img
        :src="fv"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Fort Victoria"
      />
      <v-img
        :src="vs2"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="vs2"
      />
      <v-img
        :src="idv"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Isabelle De Valenzuela"
      />
      <v-img
        :src="vdm"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Victoria De Makati"
      />
      <v-img
        :src="vdm2"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Victoria De Manila"
      />
      <v-img
        :src="vdm3"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Victoria De Morato"
      />
      <v-img
        :src="vs1"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Victoria Station 1"
      />
      <v-img
        :src="vt"
        class="mb-2 mx-2 shining-effect"
        max-height="100"
        max-width="100"
        alt="Victoria Towers"
      />
    </v-row>
  </div>
</template>

<script>
import hero2 from "@/assets/hero-provalue.jpg";
import hero3 from "@/assets/hero3.png";
import hero4 from "@/assets/hero4.jpeg";
import mpbl from "@/assets/mpbl.jpg";
//
import ft from "@/assets/towers/ft.png";
import fv from "@/assets/towers/fv.png";
import idv from "@/assets/towers/idv.png";
import vdm from "@/assets/towers/vdm.png";
import vdm2 from "@/assets/towers/vdm2.png";
import vdm3 from "@/assets/towers/vdm3.png";
import vs1 from "@/assets/towers/vs1.png";
import vs2 from "@/assets/towers/vs2.png";
import vt from "@/assets/towers/vt.png";
//
import franchesca from "@/assets/buildings/franchesca-bldg.png";
import fortvic from "@/assets/buildings/fv-bldg.png";
import isabelle from "@/assets/buildings/idv-bldg.png";
import manila from "@/assets/buildings/vdm-bldg.png";
import manila2 from "@/assets/buildings/vdm1-bldg.png";
import morato from "@/assets/buildings/vdm2-bldg.png";
import makati from "@/assets/buildings/vdmkt-bldg.png";
import victoria1 from "@/assets/buildings/vs1-bldg.png";
import victoria2 from "@/assets/buildings/vs2-bldg.png";
import victoria from "@/assets/buildings/vt-bldg.png";

export default {
  data: () => ({
    hero2,
    hero3,
    hero4,
    //
    ft,
    fv,
    idv,
    vdm,
    vdm2,
    vdm3,
    vs1,
    vs2,
    vt,
    //
    franchesca,
    fortvic,
    isabelle,
    manila,
    morato,
    makati,
    victoria1,
    victoria2,
    victoria,
    manila2,
  }),
};
</script>

<style>
.shining-effect {
  position: relative;
  overflow: hidden;
}

.shining-effect::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 70%
  );
  transform: rotate(0deg);
  animation: shine 2s infinite;
}

@keyframes shine {
  0% {
    transform: rotate(25deg) translate(-100%, -100%);
  }
  100% {
    transform: rotate(25deg) translate(100%, 100%);
  }
}
</style>
